<template>
    <div class="scroll cards">
        <template v-if="cards">
            <draggable
                group="cards"
                class="cards-list"
                :value="cards.data.results"
                @change="move_card">

                <card-list-item
                    v-for="card in cards.data.results"
                    :key="card.id"
                    :space="space"
                    :card="card"
                    @select="$emit('select', card)"
                    @open_note="open_note(card)"/>
            </draggable>
        </template>

        <mugen-scroll
            :should-handle="cards && !cards.loading && !last_page"
            :handler="load"
            scroll-container="cards"
            ref="scroll">

            <p v-if="!last_page">loading...</p>
        </mugen-scroll>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import inViewport from 'element-in-view';
import MugenScroll from 'vue-mugen-scroll';
import Draggable from 'vuedraggable/src/vuedraggable';
import CardListItem from './CardListItem.vue';

export default {
    components: {
        CardListItem,
        Draggable,
        MugenScroll,
    },
    props: ['space', 'flow', 'column', 'search', 'filter_tags'],
    computed: {
        ...mapState('cards', ['list']),
        ...mapState('notes', { note_details: 'detail' }),
        cards() {
            return this.list[this.column.id];
        },
    },
    data() {
        return { last_page: false, page: 1 };
    },
    destroyed() {
        this.$store.commit('cards/clean_list');
    },
    watch: {
        search: 'reload',
        filter_tags: 'reload',
    },
    methods: {
        reload() {
            this.last_page = false;
            this.page = 1;
            this.load();
        },
        async load() {
            await this.$store.dispatch('cards/list', {
                space_id: this.space.id,
                flow_id: this.flow.id,
                column: this.column.id,
                tags: this.filter_tags,
                extend: this.page > 1,
                search: this.search,
                page: this.page,
            });

            this.page += 1;
            this.last_page = !this.cards.data.next;

            // If marker (rel="scroll") in users display, load second page
            const in_element = inViewport(this.$refs.scroll.$el, { threshold: 0 });
            if (this.$refs.scroll && in_element && !this.last_page) {
                this.load();
            }
        },
        move_card(result) {
            const removed = result.moved || result.removed;
            const added = result.moved || result.added;

            if (removed) {
                this.$store.commit('cards/remove_card', {
                    column: this.column.id,
                    position: removed.oldIndex,
                });
            }

            if (added) {
                this.update_card(added.element, added.newIndex);
            }
        },
        async update_card(card, position) {
            const data = { position };
            if (['open', 'close'].includes(this.column.id)) {
                data.is_open = this.column.id === 'open';
            } else {
                data.column = this.column.id;
            }

            this.$store.commit('cards/add_card', { column: this.column.id, position, card });

            await this.$store.dispatch('cards/update', {
                space_id: this.space.id,
                flow_id: this.flow.id,
                card_id: card.id,
                data,
            });
        },
    },
};
</script>

<style scoped>
    .cards {
        height: calc(100% - 3rem);
        padding-bottom: 2rem;
    }

    .cards-list {
        height: calc(100% - 3rem);
    }

    .card-ghost {
        transition: transform 0.18s ease;
        transform: rotateZ(5deg)
    }
    .card-ghost-drop {
        transition: transform 0.18s ease-in-out;
        transform: rotateZ(0deg)
    }
</style>
